// utils/reverseMapping.js
import statMapping from "../constants/StatMapping";

export const getRawStatName = (shortName) => {
  const reverseMap = Object.entries(statMapping).reduce((acc, [raw, short]) => {
    acc[short.toLowerCase()] = raw; // store lowercase version of short names
    return acc;
  }, {});

  return reverseMap[shortName.toLowerCase()] || shortName;
};
